"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberUtils = void 0;
const lpnUtilMax = __importStar(require("libphonenumber-js/max"));
const exceptions_1 = require("../exceptions");
const regexp_1 = require("../regexp");
const other_1 = require("../exceptions/common-exceptions/exceptions/other");
const phone_number_enums_1 = require("./phone-number.enums");
/**
 * Класс для телефонных номеров
 *
 * @example Пример использования:
 *
 * const phoneNumber = PhoneNumberUtils
 *  .parseWithException('78787987898', 'RU')
 *  .filteredByTypeWithException([ EPhoneNumberType.MOBILE ])
 *  .isValidWithException()
 *  .format(EPhoneNumberFormat.INTERNATIONAL)
 */
class PhoneNumberUtils {
    constructor(lpnClass) {
        this.lpnClass = lpnClass;
    }
    get number() {
        return this.lpnClass.number;
    }
    getType() {
        return this.numberTypeMap(this.lpnClass.getType());
    }
    getCountryCode() {
        return this.lpnClass.country;
    }
    /**
     * Возвращает номер телефона в указанном формате
     */
    format(format) {
        return this.lpnClass.format(this.numberFormatMap(format));
    }
    /**
     * Возвращает номер телефона в формате NATIONAL
     */
    formatNational() {
        return this.format(phone_number_enums_1.EPhoneNumberFormat.NATIONAL);
    }
    /**
     * Проверяет соответвует ли тип телефонного номера хотябы одному из
     * переданного массива типов
     */
    isType(types) {
        return types.includes(this.getType());
    }
    /**
     * Проверяет соответвует ли тип телефонного номера хотябы одному из
     * переданного массива типов
     *
     * @returns this - если номер соответствует
     * @returns null - если номер не соответствует
     */
    filteredByType(types) {
        if (!this.isType(types)) {
            return null;
        }
        return this;
    }
    /**
     * Проверяет соответвует ли тип телефонного номера хотябы одному из
     * переданного массива типов
     *
     * @returns this - если номер соответствует
     * @throws {CommonException} - если номер не соответствует
     */
    filteredByTypeWithException(types) {
        if (!this.isType(types)) {
            throw new exceptions_1.CommonException({
                type: 'PhoneNumberFilteredByTypeException',
                message: 'The phone number does not match any type in the array',
                payload: {
                    types
                }
            });
        }
        return this;
    }
    /**
     * Проверяет номер на валидность
     */
    isValid() {
        return this.lpnClass.isValid();
    }
    /**
     * Проверяет номер на валидность
     *
     * @throws {CommonValidateException} - если номер не валиден
     */
    isValidWithException() {
        if (!this.isValid()) {
            throw new other_1.CommonValidateException({
                message: 'Invalid phone number'
            });
        }
        return this;
    }
    /**
     * Парсит строку с номером и возвращает класс CommonsPhoneNumber
     */
    static parse(number, defaultCountry) {
        try {
            return this.parseWithException(number, defaultCountry);
        }
        catch (_a) {
            return null;
        }
    }
    /**
     * Парсит строку с номером и возвращает класс CommonsPhoneNumber
     *
     * @throws {CommonValidateException} - если не удалось спарсить номер
     */
    static parseWithException(number, defaultCountry) {
        try {
            number = number
                .replace(regexp_1.REGEXP_IS_RUSSIAN_NUMBER, '+79$2')
                .replace(regexp_1.REGEXP_NON_PHONE_SYMBOLS, '');
            const phoneNumber = lpnUtilMax
                .parsePhoneNumberWithError(number, defaultCountry);
            return new PhoneNumberUtils(phoneNumber);
        }
        catch (error) {
            throw new other_1.CommonValidateException({
                message: 'Phone number parse error',
                cause: error
            });
        }
    }
    static isPhoneNumber(input, options = {}) {
        const res = {
            isValid: false,
            formatted: false,
            original: input,
            type: false,
            lpnType: false
        };
        const parsedNumber = PhoneNumberUtils.parse(input, 'RU');
        if (!(parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.isValid())) {
            return res;
        }
        res.formatted = parsedNumber.number;
        res.lpnType = parsedNumber.getType();
        switch (res.lpnType) {
            case phone_number_enums_1.EPhoneNumberType.FIXED_LINE_OR_MOBILE:
            case phone_number_enums_1.EPhoneNumberType.MOBILE:
                res.type = phone_number_enums_1.EPhoneNumberTypeSimplified.mobile;
                break;
            case phone_number_enums_1.EPhoneNumberType.PERSONAL_NUMBER:
            case phone_number_enums_1.EPhoneNumberType.FIXED_LINE:
                res.type = phone_number_enums_1.EPhoneNumberTypeSimplified.home;
                break;
            case phone_number_enums_1.EPhoneNumberType.PAGER:
            case phone_number_enums_1.EPhoneNumberType.VOIP:
            case phone_number_enums_1.EPhoneNumberType.TOLL_FREE:
                res.type = phone_number_enums_1.EPhoneNumberTypeSimplified.work;
                break;
            default:
                res.type = false;
                break;
        }
        if (options.pntFilter && !parsedNumber.filteredByType(options.pntFilter) ||
            res.type && options.typeFilter && !options.typeFilter.includes(res.type)) {
            return res;
        }
        res.isValid = true;
        return res;
    }
    static parseAndConvertPhoneNumber(phoneNumber, convertTo = 'e164') {
        const lpnPhoneNumber = PhoneNumberUtils.parseWithException(phoneNumber, 'RU');
        switch (convertTo) {
            case 8:
            case 'national':
                return lpnPhoneNumber.format(phone_number_enums_1.EPhoneNumberFormat.NATIONAL);
            case 1:
            case 'e164':
            default:
                return lpnPhoneNumber.number;
        }
    }
    numberFormatMap(format) {
        switch (format) {
            case phone_number_enums_1.EPhoneNumberFormat.NATIONAL:
                return 'NATIONAL';
            case phone_number_enums_1.EPhoneNumberFormat.INTERNATIONAL:
                return 'INTERNATIONAL';
            case phone_number_enums_1.EPhoneNumberFormat.E164:
                return 'E.164';
            case phone_number_enums_1.EPhoneNumberFormat.RFC3966:
                return 'RFC3966';
        }
    }
    numberTypeMap(type) {
        if (!type) {
            return phone_number_enums_1.EPhoneNumberType.UNKNOWN;
        }
        switch (type) {
            case 'MOBILE':
                return phone_number_enums_1.EPhoneNumberType.MOBILE;
            case 'UAN':
                return phone_number_enums_1.EPhoneNumberType.UAN;
            case 'VOIP':
                return phone_number_enums_1.EPhoneNumberType.VOIP;
            case 'PAGER':
                return phone_number_enums_1.EPhoneNumberType.PAGER;
            case 'TOLL_FREE':
                return phone_number_enums_1.EPhoneNumberType.TOLL_FREE;
            case 'VOICEMAIL':
                return phone_number_enums_1.EPhoneNumberType.VOICEMAIL;
            case 'FIXED_LINE':
                return phone_number_enums_1.EPhoneNumberType.FIXED_LINE;
            case 'SHARED_COST':
                return phone_number_enums_1.EPhoneNumberType.SHARED_COST;
            case 'PREMIUM_RATE':
                return phone_number_enums_1.EPhoneNumberType.PREMIUM_RATE;
            case 'PERSONAL_NUMBER':
                return phone_number_enums_1.EPhoneNumberType.PERSONAL_NUMBER;
            case 'FIXED_LINE_OR_MOBILE':
                return phone_number_enums_1.EPhoneNumberType.FIXED_LINE_OR_MOBILE;
        }
    }
}
exports.PhoneNumberUtils = PhoneNumberUtils;
//# sourceMappingURL=phone-number-utils.class.js.map